@if (showChecklist) {
  <div class="card shadow-sm border-0">
    <div class="card-body text-center">
      <i class="bi bi-clipboard-list-outline fs-2 text-primary"></i>
      <h5 class="card-title mt-2 fw-bold">{{ 'TEAM.SCORE.CHECKLIST.SETUP_PROGRESS_TITLE' | translate }}</h5>
      <p class="card-text text-muted small mb-4">{{ 'TEAM.SCORE.CHECKLIST.SETUP_PROGRESS_SUBTITLE' | translate }}</p>

      <ul class="list-unstyled text-start w-100 mb-4">
        @for (item of checklist; track item.textKey) {
          <li class="d-flex align-items-center mb-2" [class.text-success]="item.isCompleted">
            @if (item.isCompleted) {
              <i class="bi bi-check-circle-fill me-2"></i>
            } @else {
              <i class="bi bi-circle me-2"></i>
            }
            <span [class.fw-semibold]="item.isCompleted">{{ item.textKey | translate }}</span>
          </li>
        }
      </ul>

      @if (nextStepTextKey) {
        <p class="small fw-bold text-primary mb-3">{{ nextStepTextKey | translate }}</p>
      }

      <button class="btn btn-primary w-100" (click)="onGetStartedClick()">{{ 'TEAM.SCORE.CHECKLIST.GET_STARTED_BUTTON' | translate }}</button>
    </div>
  </div>
} @else {
  <div class="iro-score-container h-100 d-flex flex-column">

    @if (isLoading) {
      <div class="card-body text-center py-5 flex-grow-1 d-flex flex-column justify-content-center">
        <div class="spinner-border text-primary mx-auto" role="status">
          <span class="visually-hidden">{{ 'TEAM.SCORE.SCORE_CARD.LOADING' | translate }}</span>
        </div>
        <p class="text-muted mt-2 small">{{ 'TEAM.SCORE.SCORE_CARD.CALCULATING_IRO' | translate }}</p>
      </div>
    } @else if (latestScore) {
      <div class="d-flex flex-column align-items-stretch px-3">
        
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="fw-bold text-muted text-uppercase mb-0">{{ 'TEAM.SCORE.SCORE_CARD.ROBUSTNESS_SCORE' | translate }}</h6>
          </div>
        
        <div class="d-flex flex-column align-items-center mb-3">
          <div class="score-circle-placeholder d-flex flex-column justify-content-center align-items-center"
               [class]="overallScoreColor">
               <span class="h2 fw-bolder mb-0" [class]="overallScoreColor">
                  {{ latestScore.score | number:'1.0-0' }}%
               </span>
               <small class="text-uppercase" [class]="overallScoreColor">
                      {{ latestScore.getRobustnessLevel() }}
               </small>
          </div>
        </div>
        
        <div class="mb-3 border-top pt-3">
          <div class="list-group list-group-flush small">
            @for (scoreItem of subScoresDisplay; track scoreItem.name) {
              <div class="list-group-item px-0 py-2 bg-transparent">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <small class="fw-semibold text-dark">{{ scoreItem.name }}</small>
                  <small class="fw-bold" [class]="getColorClassStatic(scoreItem.score)">{{ scoreItem.score | number:'1.0-0' }}%</small>
                </div>
                
                <div class="progress" role="progressbar" [style.height.px]="6">
                  <div 
                    class="progress-bar rounded-pill" 
                    [class]="scoreItem.colorClass" 
                    [style.width.%]="scoreItem.score">
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
  
        <div class="mt-2">
            <button type="button" class="btn btn-sm btn-outline-primary w-100" (click)="openAiAnalysisModal()">
                <i class="bi bi-robot me-2"></i> {{ 'TEAM.SCORE.SCORE_CARD.GET_AI_ANALYSIS' | translate }}
            </button>
        </div>
      </div>
    } @else {
      <div class="card-body text-center py-5 flex-grow-1 d-flex flex-column justify-content-center">
        <p class="text-muted small">{{ 'TEAM.SCORE.SCORE_CARD.IRO_SCORE_UNAVAILABLE' | translate }}</p>
      </div>
    }
  </div>
}

@if (showAiAnalysisModal) {
    <div class="modal fade show d-block" id="aiAnalysisModal" tabindex="-1" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="bi bi-robot me-2"></i>
                        {{ 'TEAM.SCORE.SCORE_CARD.AI_ANALYSIS_TITLE' | translate }}
                    </h5>
                    <button type="button" class="btn-close" (click)="closeAiAnalysisModal()" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    
                    @if (loadingAnalysis) {
                        <div class="d-flex align-items-center justify-content-center py-5">
                            <div class="spinner-border text-primary me-2" role="status"></div>
                            <strong>{{ 'TEAM.SCORE.SCORE_CARD.GENERATING_ANALYSIS' | translate }}</strong>
                        </div>
                    } @else {
                        <div class="analysis-content">
                            <markdown [data]="aiAnalysisText"></markdown>
                        </div>
                    }

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeAiAnalysisModal()">{{ 'TEAM.SCORE.SCORE_CARD.CLOSE' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
}